import { Link, useLocation } from "react-router-dom";
import PageLayout from "@/components/feature/PageLayout";
import usePageMeta from "@/hooks/usePageMeta";
import { categories } from "@/lib/movieData";

export default function NotFound() {
  const location = useLocation();

  usePageMeta({
    title: "页面不存在 - 秋霞电影",
    description: "你访问的页面不存在或已被调整，可以从首页或电影分类重新进入秋霞电影。",
    keywords: "秋霞电影,页面不存在,电影资讯",
  });

  return (
    <PageLayout>
      <section className="w-full bg-background-100">
        <div className="max-w-[760px] mx-auto px-4 md:px-6 py-20 md:py-28 text-center">
          <p className="font-heading text-6xl md:text-8xl text-background-300 select-none">404</p>
          <h1 className="mt-4 font-heading text-2xl md:text-3xl text-foreground-950">
            这个页面没有找到
          </h1>
          <p className="mt-3 text-sm text-foreground-600 break-all">访问路径：{location.pathname}</p>
          <p className="mt-2 text-sm text-foreground-600">
            链接可能已被调整，试试从下面的入口继续浏览影片资料。
          </p>

          <div className="mt-7 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="h-11 px-6 inline-flex items-center rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              返回首页
            </Link>
            <Link
              to="/search"
              className="h-11 px-6 inline-flex items-center gap-2 rounded-md border border-background-300 text-foreground-700 text-sm hover:border-primary-400 transition-colors whitespace-nowrap"
            >
              <i className="ri-search-line"></i>
              搜索影片
            </Link>
          </div>

          <div className="mt-10 flex flex-wrap justify-center gap-2">
            {categories.map((category) => (
              <Link
                key={category.slug}
                to={`/category/${category.slug}`}
                className="h-9 px-4 inline-flex items-center rounded-full border border-background-300 bg-background-50 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                {category.name}
              </Link>
            ))}
          </div>
        </div>
      </section>
    </PageLayout>
  );
}